import { render } from "./AposTiptapImage.vue?vue&type=template&id=060e4566&scoped=true"
import script from "./AposTiptapImage.vue?vue&type=script&lang=js"
export * from "./AposTiptapImage.vue?vue&type=script&lang=js"

import "./AposTiptapImage.vue?vue&type=style&index=0&id=060e4566&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060e4566"],['__file',"rich-text-widget/ui/apos/components/AposTiptapImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "060e4566"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('060e4566', __exports__)) {
    api.reload('060e4566', __exports__)
  }
  
  module.hot.accept("./AposTiptapImage.vue?vue&type=template&id=060e4566&scoped=true", () => {
    api.rerender('060e4566', render)
  })

}


export default __exports__